import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import AppAside from "@/layout/AppAside.vue";
Vue.use(VueRouter);
Vue.component("AppAside", AppAside);
import notfound from "@/views/not_found.vue";

const login = () => import("@/views/Login.vue");

const services = () => import("@/views/services/services");
const service = () => import("@/views/services/service");
const servicesTable = () => import("@/views/services/servicesTable");

const categories = () => import("@/views/categories");
const products = () => import("@/views/products/products");
const product = () => import("@/views/products/product");
const productsTable = () => import("@/views/products/productsTable");

const orders = () => import("@/views/orders/orders");
const productsOrders = () => import("@/views/orders/productsOrders");
const customers = () => import("@/views/customers/customers");
const customer = () => import("@/views/customers/customer");
const customersTable = () => import("@/views/customers/customersTable");
const dashboard = () => import("@/views/dashboard");
const countries = () => import("@/views/countries");
const banners = () => import("@/views/banners");

const coupons = () => import("@/views/coupons");
const pages = () => import("@/views/pages");
const workers = () => import("@/views/workers/workers");
const worker = () => import("@/views/workers/worker");
const settings = () => import("@/views/settings");
const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboard,
    meta: {
      title: "dashboard",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },

  {
    path: "/services",
    component: services,
    meta: {
      title: "services",
      requiresAuth: true,
      role: ["superAdmin"],
    },
    children: [
      {
        path: "/",
        name: "services",
        component: servicesTable,
        meta: {
          role: ["superAdmin"],
          title: "services",
          requiresAuth: true,
        },
      },
      {
        path: "service/:id?",
        name: "service",
        component: service,
        meta: {
          role: ["superAdmin"],
          title: "service",
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: "/products",
    component: products,
    meta: {
      title: "products",
      requiresAuth: true,
      role: ["superAdmin", "admin"],
    },
    children: [
      {
        path: "/",
        name: "products",
        component: productsTable,
        meta: {
          role: ["superAdmin", "admin"],
          title: "products",
          requiresAuth: true,
        },
      },
      {
        path: "product/:id?",
        name: "product",
        component: product,
        meta: {
          role: ["superAdmin", "admin"],
          title: "product",
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: "/categories",
    name: "categories",
    component: categories,
    meta: {
      title: "categories",
      requiresAuth: true,
      role: ["superAdmin", "admin"],
    },
  },
  {
    path: "/orders",
    name: "orders",
    component: orders,
    meta: {
      title: "orders",
      requiresAuth: true,
      role: ["superAdmin", "admin"],
    },
  },
  {
    path: "/productsOrders",
    name: "productsOrders",
    component: productsOrders,
    meta: {
      title: "productsOrders",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },

  {
    path: "/customers",
    component: customers,
    meta: {
      title: "customers",
      requiresAuth: true,
      role: ["superAdmin"],
    },
    children: [
      {
        path: "/",
        name: "customers",
        component: customersTable,
        meta: {
          role: ["superAdmin"],
          title: "customers",
          requiresAuth: true,
        },
      },
      {
        path: "customer/:id?",
        name: "customer",
        component: customer,
        meta: {
          role: ["superAdmin"],
          title: "customer",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/countries",
    name: "countries",
    component: countries,
    meta: {
      title: "countries",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },
  {
    path: "/banners",
    name: "banners",
    component: banners,
    meta: {
      title: "banners",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },

  {
    path: "/coupons",
    name: "coupons",
    component: coupons,
    meta: {
      title: "coupons",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },
  {
    path: "/pages",
    name: "pages",
    component: pages,
    meta: {
      title: "pages",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },

  {
    path: "/workers",
    name: "workers",
    component: workers,
    meta: {
      title: "workers",
      requiresAuth: true,
      role: ["superAdmin", "admin"],
    },
  },
  {
    path: "/worker/:id",
    name: "worker",
    component: worker,
    meta: {
      title: "worker",
      requiresAuth: true,
      role: ["superAdmin", "admin"],
    },
  },

  {
    path: "/settings",
    name: "settings",
    component: settings,
    meta: {
      title: "settings",
      requiresAuth: true,
      role: ["superAdmin"],
    },
  },

  //--------------- public
  {
    path: "/",
    name: "login",
    component: login,
    meta: {
      title: "login",
      requiresAuth: false,
    },
  },

  {
    path: "*",
    name: "problem",
    component: notfound,
    meta: {
      title: "notfound",
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.title;
  const loggedIn = store.getters.loggedin;
  const routeRequireAuth = to.meta.requiresAuth;
  const role = store.getters.role;
  const routeRole = to.meta.role;
  document.title = pageTitle;
  if (!loggedIn && routeRequireAuth) {
    next({ name: "login" });
    return;
  } else if (
    (!loggedIn && !routeRequireAuth) ||
    (loggedIn && to.name == "problem")
  ) {
    next();
    return;
  } else if (loggedIn && to.name == "login") {
    next({ name: "orders" });
    return;
  } else if (loggedIn && routeRole.includes(role)) {
    next();
  } else {
    next({ name: "problem" });
  }
});

export default router;
